var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon/outlined/allplaceapplication/bell",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ieq71w2yna"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/allplaceapplication/bell (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/allplaceapplication/bell (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/allplaceapplication/bell",
    style: {
      clipPath: "url(#ieq71w2yna)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/allplaceapplication/bell (clip group)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/allplaceapplication/bell (style)",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.313a2.628 2.628 0 0 1-2.625-2.625H4.312a.187.187 0 0 1-.187-.187v-.751a.751.751 0 0 1 .75-.75h.562v-7.968a6.561 6.561 0 0 1 5.625-6.494v-.912a.938.938 0 0 1 1.876 0v.912a6.561 6.561 0 0 1 5.625 6.494v7.969h.562a.751.751 0 0 1 .75.75v.751a.187.187 0 0 1-.187.187h-5.063A2.629 2.629 0 0 1 12 22.313zm-1.125-2.625a1.125 1.125 0 0 0 2.25 0zM12 5.157a4.873 4.873 0 0 0-4.875 4.875v7.969h9.75v-7.969A4.873 4.873 0 0 0 12 5.157z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlram);
export default __webpack_public_path__ + "static/media/alram.698147cf289cdfb4975547ebde15e4af.svg";
export { ForwardRef as ReactComponent };